import React from 'react';

import {
  PitchDeckTopic,
  usePitchDeckTopicSectionQuery
} from 'generated/graphql';
import _ from 'lodash';
import {
  routeDirectory,
  useLoading
} from 'modules';



const ORDERED_TOPICS = [
  'Mission',
  'Problem',
  'Solution',
  'Front Cover',
  'How It Works',
  'Revenue Model',
  'Differentiation',
  'Traction',
  'Market Size',
  'Intellectual Property',
  'Team + Stakeholders',
  'Growth Plan',
  'Funding Need',
  'Financial Projections',
  'Impact / ESG',
  'Case Study',
  'Why Now?',
  'End Cover'
];



export function usePitchDeckTopicSection() {
  const tuple = usePitchDeckTopicSectionQuery();
  const loading = useLoading([tuple]);

  const data = React.useMemo(() => {
    const reorderedTopics = reorderTopics(ORDERED_TOPICS, tuple.data?.pitchDeckTopics);

    return _.map(reorderedTopics, topic => ({
      id: topic.id,
      title: topic.title,
      bodyText: topic.bodyText,

      link: __genLinkToSlideTypePage(topic.title)
    }));

  }, [tuple.data?.pitchDeckTopics]);


  return {
    loading,
    data
  };
}



function __genLinkToSlideTypePage(originalTitle: string): string | undefined {
  if (originalTitle === 'Impact / ESG' || originalTitle === 'Why Now?') {
    return undefined;
  }

  const remappedLink = __remapTopicTitleToSlideTypeTitle(originalTitle);
  return routeDirectory.pitchDecks.title.path('bySlideType', remappedLink);
}



function __remapTopicTitleToSlideTypeTitle(originalTitle: string): string {
  if (originalTitle === 'Mission Statement') return 'Mission';
  if (originalTitle === 'Market Size') return 'Market';
  if (originalTitle === 'Team + Stakeholders') return 'Team';
  return originalTitle;
}



function reorderTopics(orderedTopics: string[], pitchDeckTopics?: PitchDeckTopic[]) {
  if (_.isUndefined(pitchDeckTopics)) return [];

  const result: typeof pitchDeckTopics = [];
  const mapArrayToObject = _.keyBy(pitchDeckTopics, 'title');

  _.each(orderedTopics, topic => {
    result.push(mapArrayToObject[topic]);
  });

  return result;
}
